// To download userguidebook and script.
export const downloadFile = (fileUrl: string, fileName: string) => {
  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = fileName; // Set the desired file name
  link.target = '_blank';
  link.click();
};
